import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';

const CLASS_OPTIONS = [
  'Pre-KG / KG',
  'Class 1-5',
  'Class 6-8',
  'Class 9-10',
  'Class 11-12',
  'Competitive Exam',
];

export default function RegistrationForm({ form, updateField, onSubmit, loading, error }) {
  return (
    <form onSubmit={onSubmit} className="relative bg-white rounded-3xl border-2 border-[#2C3E50] p-6 lg:p-8 paper-shadow">
      <div className="absolute -top-6 -right-4 bg-[#4FB3B8] border-2 border-[#2C3E50] rounded-full px-4 py-2 paper-shadow-sm rotate-3">
        <div className="text-[10px] uppercase tracking-widest font-black text-white/90">Demo class</div>
        <div className="flex items-center gap-1 text-xl font-black text-white" style={{ fontFamily: 'Fraunces, serif' }}>
          <Sparkles size={16} strokeWidth={3} /> 100% FREE
        </div>
      </div>

      <h3 className="text-2xl font-black text-[#2C3E50]" style={{ fontFamily: 'Fraunces, serif' }}>Your details</h3>
      <p className="text-[#2C3E50]/70 text-sm mt-1 font-semibold">Takes less than 60 seconds.</p>

      <div className="mt-6 grid sm:grid-cols-2 gap-5">
        <div>
          <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Parent name*</label>
          <input required value={form.name} onChange={updateField('name')} placeholder="e.g. Anjali Sharma" className="mt-1 w-full px-4 py-3 bg-[#FFF8EC] border-2 border-[#2C3E50] rounded-lg font-semibold placeholder:text-[#2C3E50]/40 focus:outline-none focus:ring-2 focus:ring-[#E64B2B]" />
        </div>
        <div>
          <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Phone number*</label>
          <input required value={form.phone} onChange={updateField('phone')} type="tel" placeholder="+91 98XXXXXXXX" className="mt-1 w-full px-4 py-3 bg-[#FFF8EC] border-2 border-[#2C3E50] rounded-lg font-semibold placeholder:text-[#2C3E50]/40 focus:outline-none focus:ring-2 focus:ring-[#E64B2B]" />
        </div>
        <div className="sm:col-span-2">
          <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Email (optional)</label>
          <input value={form.email} onChange={updateField('email')} type="email" placeholder="anjali@example.com" className="mt-1 w-full px-4 py-3 bg-[#FFF8EC] border-2 border-[#2C3E50] rounded-lg font-semibold placeholder:text-[#2C3E50]/40 focus:outline-none focus:ring-2 focus:ring-[#E64B2B]" />
        </div>
        <div>
          <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Class*</label>
          <select required value={form.student_class} onChange={updateField('student_class')} className="mt-1 w-full px-4 py-3 bg-[#FFF8EC] border-2 border-[#2C3E50] rounded-lg font-semibold focus:outline-none focus:ring-2 focus:ring-[#E64B2B]">
            <option value="">Select class</option>
            {CLASS_OPTIONS.map((opt) => (
              <option key={opt}>{opt}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Subject (optional)</label>
          <input value={form.subject} onChange={updateField('subject')} placeholder="e.g. Maths, Science" className="mt-1 w-full px-4 py-3 bg-[#FFF8EC] border-2 border-[#2C3E50] rounded-lg font-semibold placeholder:text-[#2C3E50]/40 focus:outline-none focus:ring-2 focus:ring-[#E64B2B]" />
        </div>
      </div>

      {error && (
        <div className="mt-5 px-4 py-3 rounded-lg bg-[#E64B2B]/10 border-2 border-[#E64B2B] text-[#E64B2B] font-bold text-sm">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="mt-6 w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-lg bg-[#E64B2B] text-white font-black border-2 border-[#2C3E50] paper-shadow-sm hover:-translate-y-0.5 disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:translate-y-0"
      >
        {loading ? (
          <>
            <Loader2 size={18} className="animate-spin" /> Submitting…
          </>
        ) : (
          <>
            Register for FREE Demo <Sparkles size={18} strokeWidth={3} />
          </>
        )}
      </button>
      <p className="mt-3 text-xs text-[#2C3E50]/60 text-center font-semibold">
        No payment now. Our counsellor will call within 30 minutes to schedule your FREE demo class.
      </p>
    </form>
  );
}
